import "./content.css"

export default  function Content()
{
    return(
        <div>
<section className="main--content" id="content">
  <h3 className="titels">Let's work Together</h3>
  <div className="service__continar">
    <div className=" content__continar--card">
      <div className="icon"><i id="icon" className="fa-solid fa-phone" /></div>
      <div className="info">
        <h3> phone</h3>
        <p> +962 0788254001</p>
      </div>
    </div>
    <div className=" content__continar--card">
      <div className="icon">
        <i id="icon" className="fa-solid fa-envelope" /></div>
      <div className="info"> 
        <h3>    Email </h3> 
        <p>mohammed bzoor777 @gmail.com</p>
      </div>
    </div>
  </div>
</section>

          <div className="hero_img">
          </div>
    <div className="footer">
   

  <p className="footer-title"> <span className="footer_title">Mohammad AL Bzoor </span></p>
  <div className="footer_social">
            <a href="https://www.linkedin.com/in/mohammed-al-bzoor-774b12329?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app ">
            <i class="fa-brands fa-linkedin" id="so"/></a>
            <a href="https://www.snapchat.com/add/m7md_bz?sender_web_id=a8230138-2cc3-4c8f-9e3a-b16e82757912&device_type=desktop&is_copy_url=true">
              <i className="fa-brands fa-snapchat" id="so"/>
            </a>
            <a href="https://www.instagram.com/cx.ili9/?utm_medium=copy_linkc">
              <i className="fa-brands fa-instagram" id="so"/>
            </a>
            <a href="https://www.youtube.com/@MohammadAlBzoor-2004/videos">
              <i className="fa-brands fa-youtube" id="so"/>
            </a>
          </div> 

    </div>
          
 
        </div>
    )
}